<!-- <app-navbar></app-navbar> -->
<!-- <div class=".dashboard">
    <div id="header">
        <nav>
            <ul>
                <li><img [src]='displayedImageGrupo176Logo' height="54" alt="text"></li>
                <li><a href="#">About Us?</a></li>
                <li><a href="#">Crow-Seeding</a></li>
                <li><a href="#">Rewards</a></li>
                <li><img [src]='displayedImageGrupo176' alt="text"></li>
                <li><a href="#">Packages</a></li>
                <li><a href="#">Marketplace</a></li>
                <li><a href="#"></a></li>
                <li><a href="#"></a></li>
            </ul>
        </nav>
    </div>
    <div id="content-1">
        <div class="image-grupo84">
            <div class="logo-kannabis">
                <div class="image-logo-kannabys"></div>
                <p><b>Welcome to</b></p>
                <p>the largest city inspired by cannabis.</p>
            </div>
            <div class="image-grupo86"></div>
        </div>
        <div class="box-green">
            <p><b>Build your cannabis farm and earn real money</b></p> 
            <p>well tell you more</p>
        </div>
    </div>
    <div class="content-2">
        <div class="imagen-grupo114"></div>
        <div class="text-group-content-2">
            <h1>About Us?</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
        </div>
    </div>
    <div class="content-3">
        <div class="imagen-grupo80"></div>
    </div>
    <div class="content-4">
        <div class="imagen-grupo91"></div>
    </div>
    <div class="content-5">
        <div class="titulo-content-5">
            <h1>Buy your plants</h1>
        </div>
        <div class="container-card">
            <div class="card">

            </div>
        </div>
        <p>For aditional questions, please contact questions@kannabyscity.co</p>
        <h2>Contact Us</h2>

    </div>
    <div class="content-6">
        <div class="imagen-grupo128"></div>
    </div>
    <router-outlet></router-outlet>
</div> -->

<router-outlet></router-outlet>


<!--spinner-->
<ngx-spinner size="medium" type="triangle-skew-spin" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>